import sortBy from 'lodash/sortBy'
import {fromJust, fromMaybe} from '@freckle/maybe'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'
import {formattedName} from '@freckle/educator-entities/ts/users/models/teacher'
import {Dropdown} from '@freckle/educator-materials/ts/components/dropdown'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {flatOptions} from '@freckle/educator-materials/ts/logic/dropdown'
import {teacherDropdown} from './teacher-picker.module.scss'

type Props = {
  teachers: Array<BaseTeacherAttrs>
  currentTeacherId: number | undefined | null
  onChangeTeacher: (teacherId?: number) => void
}

export function TeacherPicker(props: Props) {
  const {teachers, currentTeacherId, onChangeTeacher} = props
  const {t} = useSafeTranslation()

  const showingAllTeachers = currentTeacherId === null || currentTeacherId === undefined

  const currentTeacher = fromMaybe(
    () => fromJust(teachers[0], 'Could not set a current teacher in teacher picker'),
    teachers.find(teacher => teacher.id === currentTeacherId)
  )

  const sortedTeachers = sortBy(teachers, teacher => teacher.lastName)

  const teacherItems = sortedTeachers.map(teacher => ({
    label: formattedName(teacher),
    value: teacher.id.toString()
  }))

  const allTeachersOption = {label: t('TEACHER_PICKER_MENU_ITEM_ALL'), value: 'AllTeachers'}

  const menuItems = [allTeachersOption, ...teacherItems]

  const value = showingAllTeachers
    ? allTeachersOption
    : {label: formattedName(currentTeacher), value: currentTeacherId.toString()}

  return (
    <div className={teacherDropdown}>
      <div id="teacher-picker-dropdown">
        <Dropdown
          labelText={t('TEACHER_PICKER_LABEL')}
          options={flatOptions(menuItems)}
          value={value}
          handleChange={input => {
            if (input === null) return
            onChangeTeacher(input.value === 'AllTeachers' ? undefined : parseInt(input.value, 10))
          }}
        />
      </div>
    </div>
  )
}
